// extracted by mini-css-extract-plugin
export default {"title":"VerifyIdentity_title__MliM5","peida":"VerifyIdentity_peida__7rDBK","logoImg":"VerifyIdentity_logoImg__ldWbS"};